import { CedulaReclutamientoForm } from '../../../Components/Empleado/CedulaReclutamientoForm';
import { DiscapacidadEmpleadoForm } from '../../../Components/Empleado/DiscapacidadEmpleadoForm';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useEffect, useState } from 'react';
import { Controller, useFieldArray, useForm, useWatch } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import swal from 'sweetalert';
import Loading from '../../../Components/Modals/Loading/Loader';

import { Box, Divider, FormControlLabel, Grid, IconButton, Paper, Stack, Typography } from '@mui/material';

import { Delete } from '@mui/icons-material';
import Avatar from '@mui/material/Avatar';
import moment from 'moment';
import { BiSave } from 'react-icons/bi';
import { MdCancel } from 'react-icons/md';
import MaskedInput from 'react-input-mask';
import Select from 'react-select';
import CurrencyInput from '../../../Components/InputSalario/CurrencyInput';
import InsertarAjustarImagen from '../../../Components/Modals/Empleados/InsertarAjustarImagen';

import { convertNumberPhoneToString } from '../../../utils/convertNumberPhoneToString';

import {
  fetchEstadosCiviles,
  fetchNacionalidades,
  fetchProgramas,
  fetchTipoEmpleados,
  fetchUbicaciones,
  selectAllEstadosCiviles,
  selectAllNacionalidades,
  selectAllPogramas,
  selectAllTiposEmpleados,
  selectUbicaciones,
} from '../../../redux/Utility/UtilitySlice';

import { fetchHorarios, selectAllHorarios } from '../../../redux/Horarios/HorarioSlice';

import { fetchAreasOrganizacionales, selectAllAreasOrganizacionales } from '../../../redux/AreaOrganizacional/AreaOrganizacionalSlice';

import { fetchCargosLista, selectAllCargosLista } from '../../../redux/Cargos/CargosSlice';

import { fetchGetTipoAccionesAll, selectListTipoAcciones } from '../../../redux/TipoAcciones/TipoAccionesSlice';

import {
  fetchCambiarSuccess,
  fetchPostAccionReclutamiento,
  selectIsLoading,
  selectIsSuccess,
  selectMessage,
} from '../../../redux/Acciones/AccionesSlice';

import { selectUserData } from '../../../redux/Login/LoginSlice';

import 'react-datepicker/dist/react-datepicker.css';
import { saveAreaOrganizacional } from '../../../utils/funcsAreaOrganizacionalPadre';
import { grupoOcupacionalesEnum } from '../../../utils/grupoOcupacionalesEnum';
import { sexos } from '../../../utils/sexosEmpleado';

export function ReclutamientoSeleccionAgregar() {
  // * FECHA ACTUAL
  const fechaActual = new Date();

  // ? HOOK-NAVIGATE
  const navigate = useNavigate();

  // ? HOOK-SELECTOR
  const usuario = useSelector(selectUserData);

  // ? HOOK-DISPATCH
  const dispatch = useDispatch();

  // ? HOOK-STATE DE LISTAS
  const [listaAreasState, setListaAreasState] = useState([]);
  const [listaCargosState, setListaCargosState] = useState([]);

  // ? HOOK-STATE PARA LA IMAGEN
  const [openInsertarImagen, setOpenInsertarImagen] = useState(false);

  // ? HOOK-SELECTOR
  const estadosCivil = useSelector(selectAllEstadosCiviles);
  const horarios = useSelector(selectAllHorarios);
  const programas = useSelector(selectAllPogramas);
  const tipoEmpleados = useSelector(selectAllTiposEmpleados);
  const areaOrganizacionales = useSelector(selectAllAreasOrganizacionales);
  const cargos = useSelector(selectAllCargosLista);
  const isLoading = useSelector(selectIsLoading);
  const success = useSelector(selectIsSuccess);
  const message = useSelector(selectMessage);
  const tipoAcciones = useSelector(selectListTipoAcciones);
  const nacionalidades = useSelector(selectAllNacionalidades);
  const ubicaciones = useSelector(selectUbicaciones);

  // ? HOOK-EFFECT
  useEffect(() => {
    dispatch(fetchEstadosCiviles());
    dispatch(fetchHorarios());
    dispatch(fetchProgramas());
    dispatch(fetchTipoEmpleados());
    dispatch(fetchAreasOrganizacionales());
    dispatch(fetchCargosLista());
    dispatch(fetchGetTipoAccionesAll());
    dispatch(fetchNacionalidades());
    dispatch(fetchUbicaciones());
  }, []);

  // ? HOOK-FORM
  const {
    register,
    setValue,
    formState: { errors, isSubmitting },
    trigger,
    clearErrors,
    handleSubmit,
    control,
    watch,
    reset,
    getValues,
  } = useForm({
    defaultValues: {
      detallesAccion: '',
      descripcionRRHH: '',
      listaTipoAccion: [],
      fechaEfectividad: new Date(),
      empleado: {
        tieneHijos: false,
        tieneDiscapacidad: false,
        tiposDiscapacidad: [],
        nombres: '',
        apellidos: '',
        cedula: '',
        fechaNacimiento: new Date(),
        sexo: '',
        estadoCivilId: 0,
        direccion: '',
        emailPersonal: '',
        celular: '',
        telefono: '',
        fechaIngreso: new Date(),
        tipoEmpleadoId: 0,
        programaId: 0,
        horarioId: 1,
        sueldo: '0',
        emailInstitucional: '',
        areaOrganizacionalId: 0,
        cargoId: 0,
        areaReporteId: 0,
        nacionalidadId: 155,
        ubicacionId: 1,
        areaOrganizacionalPadreId: 0,
        areaMaxima: 0,
      },
      imagenEmpleado: '',
    },
  });

  // ? HOOK-WATCH
  const empleadoAccion = useWatch({ control, name: 'empleado' });

  const { fields } = useFieldArray({
    control,
    name: 'listaTipoAccion',
    rules: {},
  });

  // ? HOOK-EFFECT PARA LAS ALERTAS
  useEffect(() => {
    if (success === 'success' && message?.length > 0) {
      reset();
      dispatch(fetchCambiarSuccess());
      swal('Exitoso!', message, 'success');
    } else if (success === 'error') {
      dispatch(fetchCambiarSuccess());
      swal('Error!', message, 'error');
    }
  }, [success]);

  useEffect(() => {
    if (empleadoAccion.cargoId !== 0) {
      const { grupoOcupacionalId = 0 } = listaCargosState.find((x) => x.id === empleadoAccion.cargoId);

      setValue(
        'empleado.areaReporteId',
        grupoOcupacionalId === grupoOcupacionalesEnum.V ? empleadoAccion.areaOrganizacionalPadreId : empleadoAccion.areaOrganizacionalId
      );
    }
  }, [empleadoAccion.areaOrganizacionalId, empleadoAccion.cargoId]);

  // * FUNCION PARA GUARDAR EL FORMULARIO
  const onSubmit = async (data, e) => {
    e.preventDefault();

    if (data.listaTipoAccion.flat().length === 0) {
      swal('Información', 'Debe seleccionar al menos una naturaleza.', 'error');
      return;
    }

    const dataApi = { ...{ usuarioLogeado: usuario.Id }, ...data };

    // * ELIMINANDO LOS CARÁCTERES DE LAS MÁSCARAS.
    dataApi.empleado.cedula = data.empleado.cedula.replace(/_/g, '').split('-').join('');
    dataApi.empleado.sueldo = data.empleado.sueldo.replace('$', '').split(',').join('');
    dataApi.empleado.telefono = convertNumberPhoneToString(data.empleado.telefono);
    dataApi.empleado.celular = convertNumberPhoneToString(data.empleado.celular);
    dataApi.empleado.flota = convertNumberPhoneToString(data.empleado.flota);
    dataApi.listaTipoAccion = dataApi.listaTipoAccion.flat();

    await dispatch(fetchPostAccionReclutamiento(dataApi));
  };

  useEffect(() => {
    setListaAreasState([{ id: 0, nombre: 'Seleccionar Área' }, ...areaOrganizacionales]);

    setListaCargosState([{ id: 0, titulo: 'Seleccionar Cargo' }, ...cargos]);
  }, [areaOrganizacionales, cargos]);

  // * ELIMINAR IMAGEN DEL EMPLEADO
  const deleteImageEmpleado = () => {
    swal({
      title: 'Estás seguro de eliminar la imagen?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setValue('imagenEmpleado', '');
      }
    });
  };

  // * FUNCION PARA IGUALAR LA FECHA DE EFECTIVIDAD Y FECHA DE INGRESO DEL EMPLEADO.
  const onChangeFechas = ({ nombre = '', value }) => {
    if (nombre === 'fechaEfectividad') {
      setValue(nombre, value);
      setValue('empleado.fechaIngreso', value);
      return;
    }

    // * EN CASO DE QUE SEA EMPLEADO.FECHA-INGRESO
    setValue(nombre, value);
    setValue('fechaEfectividad', value);

    return;
  };

  return (
    <div className="container">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row mt-2">
          <div>
            <h3 className="text-primary-mem">NUEVO EMPLEADO</h3>
            <hr />
          </div>
        </div>

        <Paper elevation={4}>
          <div className="d-flex flex-row p-3">
            <div className="col-md-4 pe-4 border-end">
              <div className="d-flex justify-content-center">
                <Avatar
                  src={watch('imagenEmpleado')}
                  sx={{
                    width: 150,
                    height: 150,
                    marginLeft: 1,
                    border: 'solid',
                    borderWidth: 1,
                    borderColor: '#003876',
                    borderRadius: 3,
                  }}
                  variant="square"
                  onClick={() => setOpenInsertarImagen(true)}
                />

                <div>
                  <IconButton onClick={() => deleteImageEmpleado()} hidden={watch('imagenEmpleado').length === 0}>
                    <Delete color="error" />
                  </IconButton>
                </div>
              </div>

              <div className="form-group">
                <label className="fw-bold">Nombres</label>
                <input
                  id="empleado.nombres"
                  className="form-control"
                  {...register('empleado.nombres', {
                    required: 'El nombre es requerido',
                  })}
                />
                <p className="text-danger">{errors.empleado?.nombres?.message}</p>
              </div>
              <div className="form-group">
                <label className="fw-bold">Apelidos</label>
                <input
                  id="empleado.apellidos"
                  className="form-control"
                  {...register('empleado.apellidos', {
                    required: 'El apellido es requerido',
                  })}
                />
                <p className="text-danger">{errors.empleado?.apellidos?.message}</p>
              </div>

              <CedulaReclutamientoForm control={control} trigger={trigger} clearErrors={clearErrors} />

              <div className="form-group">
                <label className="fw-bold">Fecha Nacimiento</label>
                <Controller
                  control={control}
                  name="ReactDatepicker"
                  {...register('empleado.fechaNacimiento', {
                    required: 'La fecha de nacimiento es requerida',
                  })}
                  render={({ field }) => (
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        InputProps={{ id: 'empleado.fechaNacimiento' }}
                        inputFormat="dd/MM/yyyy"
                        label={' '}
                        mask="__/__/____"
                        value={field.value}
                        onChange={(e) => field.onChange(e)}
                        renderInput={(params) => <TextField className="form-control" {...params} />}
                      />
                    </LocalizationProvider>
                  )}
                />

                <p className="text-danger">{errors.empleado?.fechaNacimiento?.message}</p>
              </div>

              <div className="form-group">
                <label className="fw-bold">Edad</label>
                <input disabled className="form-control" value={moment().diff(empleadoAccion?.fechaNacimiento, 'years', false)} />
              </div>

              <div className="form-group mt-2">
                <label className="fw-bold">Sexo</label>
                <Controller
                  control={control}
                  name="empleado.sexo"
                  rules={{ required: 'El sexo es requerido' }}
                  render={({ field }) => (
                    <Select
                      classNamePrefix="select"
                      isSearchable={true}
                      placeholder="Seleccionar sexo"
                      options={sexos}
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      onChange={(e) => field.onChange(e.value)}
                      value={sexos.find((x) => x.value === field.value)}
                    />
                  )}
                />
                <p className="text-danger">{errors.empleado?.sexo?.message}</p>
              </div>

              <div className="form-group">
                <label className="fw-bold">Estado Civil</label>
                <Controller
                  control={control}
                  name="empleado.estadoCivilId"
                  rules={{
                    required: 'El estado civil es requerido',
                    validate: (value) => value !== 0 || 'El estado civil es requerido',
                  }}
                  render={({ field }) => (
                    <Select
                      id="empleado.estadoCivilId"
                      classNamePrefix="select"
                      placeholder="Seleccionar Estado Civil"
                      isSearchable={false}
                      options={estadosCivil}
                      getOptionLabel={(option) => option.nombre}
                      getOptionValue={(option) => option.id}
                      onChange={(e) => field.onChange(e.id)}
                      value={estadosCivil.find((x) => x.id === field.value)}
                    />
                  )}
                />

                <p className="text-danger">{errors.empleado?.estadoCivilId?.message}</p>
              </div>
            </div>

            <div className="col-md-4 ps-4 pe-4 border-end">
              <div className="form-group">
                <label className="fw-bold">Nacionalidad</label>
                <Controller
                  control={control}
                  name="empleado.nacionalidadId"
                  rules={{
                    required: 'La nacionalidad es requerida',
                  }}
                  render={({ field }) => (
                    <Select
                      id="empleado.nacionalidadId"
                      classNamePrefix="select"
                      isSearchable={true}
                      placeholder="Seleccionar Empleado"
                      options={nacionalidades}
                      getOptionLabel={(option) => option.nombre}
                      getOptionValue={(option) => option.id}
                      onChange={(e) => field.onChange(e.id)}
                      value={nacionalidades.find((x) => x.id === field.value)}
                    />
                  )}
                />
              </div>

              <DiscapacidadEmpleadoForm control={control} setValue={setValue} />
              <div className="form-group mt-3">
                <label className="fw-bold">Dirección</label>
                <textarea id="empleado.direccion" className="form-control" {...register('empleado.direccion')} />
                <p className="text-danger" />
              </div>

              <div className="form-group">
                <label className="fw-bold">Correo Personal</label>
                <input
                  id="empleado.emailPersonal"
                  className="form-control"
                  {...register('empleado.emailPersonal', {
                    pattern: {
                      value: /\S+@\S+\.\S+/,
                      message: 'El formato de correo no es valido',
                    },
                  })}
                />
                <p className="text-danger">{errors.empleado?.emailPersonal?.message}</p>
              </div>

              <div className="form-group mb-3">
                <label className="fw-bold">Celular</label>
                <Controller
                  control={control}
                  name="empleado.celular"
                  rules={{
                    minLength: {
                      value: 14,
                      message: 'El celular debe tener 10 dígitos',
                    },
                  }}
                  render={({ field }) => (
                    <MaskedInput id="empleado.celular" mask="(999) 999-9999" maskChar="" value={field.value} onChange={field.onChange}>
                      {(inputProps) => <input className="form-control" {...inputProps} type="text" />}
                    </MaskedInput>
                  )}
                />

                <p className="text-danger">{errors.empleado?.celular?.message}</p>
              </div>

              <div className="form-group mb-3">
                <label className="fw-bold">Teléfono</label>
                <Controller
                  control={control}
                  name="empleado.telefono"
                  rules={{
                    minLength: {
                      value: 14,
                      message: 'El teléfono debe tener 10 dígitos',
                    },
                  }}
                  render={({ field }) => (
                    <MaskedInput id="empleado.telefono" mask="(999) 999-9999" maskChar="" value={field.value} onChange={field.onChange}>
                      {(inputProps) => <input className="form-control" {...inputProps} type="text" />}
                    </MaskedInput>
                  )}
                />

                <p className="text-danger">{errors.empleado?.telefono?.message}</p>
              </div>

              <div className="form-group">
                <label className="fw-bold">Fecha Ingreso</label>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    InputProps={{ id: 'empleado.fechaIngreso' }}
                    inputFormat="dd/MM/yyyy"
                    label={' '}
                    mask="__/__/____"
                    value={watch('empleado.fechaIngreso')}
                    onChange={(e) => onChangeFechas({ nombre: 'empleado.fechaIngreso', value: e })}
                    renderInput={(params) => <TextField className="form-control" {...params} />}
                  />
                </LocalizationProvider>

                <p className="text-danger mt-3">{errors.empleado?.fechaIngreso?.message}</p>
              </div>

              <div className="form-group">
                <label className="fw-bold">Tipo Empleado</label>
                <Controller
                  control={control}
                  name="empleado.tipoEmpleadoId"
                  rules={{
                    validate: (value) => value !== 0 || 'El tipo de empleado es requerido',
                  }}
                  render={({ field }) => (
                    <Select
                      id="empleado.tipoEmpleadoId"
                      classNamePrefix="select"
                      isSearchable={true}
                      placeholder="Seleccionar Tipo Empleado"
                      options={tipoEmpleados}
                      getOptionLabel={(option) => option.tipo}
                      getOptionValue={(option) => option.id}
                      onChange={(e) => field.onChange(e.id)}
                      value={tipoEmpleados.find((x) => x.id === field.value)}
                    />
                  )}
                />

                <p className="text-danger">{errors.empleado?.tipoEmpleadoId?.message}</p>
              </div>

              <div className="form-group">
                <label className="fw-bold">Programa</label>
                <Controller
                  control={control}
                  name="empleado.programaId"
                  {...register('empleado.programaId')}
                  rules={{
                    validate: (value) => value !== 0 || 'El programa es requerido',
                  }}
                  render={({ field }) => (
                    <Select
                      id="empleado.programaId"
                      classNamePrefix="select"
                      isSearchable={false}
                      placeholder="Seleccionar Programa"
                      options={programas}
                      getOptionLabel={(option) => option.programa}
                      getOptionValue={(option) => option.id}
                      onChange={(e) => field.onChange(e.id)}
                      value={programas.find((x) => x.id === field.value)}
                    />
                  )}
                />
                <p className="text-danger">{errors.empleado?.programaId?.message}</p>
              </div>

              <div className="form-group">
                <label className="fw-bold">Horario</label>
                <Controller
                  control={control}
                  name="empleado.horarioId"
                  rules={{
                    required: 'El horario es requerido',
                    validate: (value) => value !== 0 || 'El horario es requerido',
                  }}
                  render={({ field }) => (
                    <Select
                      id="empleado.horarioId"
                      classNamePrefix="select"
                      isSearchable={true}
                      placeholder="Seleccionar Horario"
                      options={horarios}
                      getOptionLabel={(option) => option.turnos[0]?.horarioLabel}
                      getOptionValue={(option) => option.id}
                      onChange={(e) => field.onChange(e.id)}
                      value={horarios.find((x) => x.id === field.value)}
                    />
                  )}
                />

                <p className="text-danger">{errors.empleado?.horarioId?.message}</p>
              </div>
            </div>

            <div className="col-md-4 ps-4 pe-4">
              <div className="form-group">
                <label className="fw-bold">Sueldo</label>

                <Controller
                  name="empleado.sueldo"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: 'El sueldo es requerido',
                  }}
                  render={({ field }) => (
                    <CurrencyInput
                      id="empleado.sueldo"
                      className="form-control"
                      placeholder="$0.00"
                      type="text"
                      value={field.value}
                      onChange={field.onChange}
                    />
                  )}
                />

                <p className="text-danger">{errors.empleado?.sueldo?.message}</p>
              </div>

              <div className="form-group">
                <label className="fw-bold">Correo Institucional</label>
                <input
                  id="empleado.emailInstitucional"
                  className="form-control"
                  {...register('empleado.emailInstitucional', {
                    pattern: {
                      value: /\S+@\S+\.\S+/,
                      message: 'El formato de correo no es valido',
                    },
                  })}
                />
                <p className="text-danger">{errors.empleado?.emailInstitucional?.message}</p>
              </div>

              <div className="form-group mb-3">
                <label className="fw-bold">Flota</label>
                <Controller
                  control={control}
                  name="empleado.flota"
                  rules={{
                    minLength: {
                      value: 14,
                      message: 'La flota debe tener 10 dígitos',
                    },
                  }}
                  render={({ field }) => (
                    <MaskedInput id="empleado.flota" mask="(999) 999-9999" maskChar="" value={field.value} onChange={field.onChange}>
                      {(inputProps) => <input className="form-control" {...inputProps} type="text" />}
                    </MaskedInput>
                  )}
                />

                <p className="text-danger mt-2">{errors.empleado?.flota?.message}</p>
              </div>

              <div className="form-group">
                <label className="fw-bold">Ubicación</label>
                <Controller
                  control={control}
                  name="empleado.ubicacionId"
                  rules={{
                    validate: (value) => value !== 0 || 'La ubicación es requerida',
                  }}
                  render={({ field }) => (
                    <Select
                      id="empleado.ubicacionId"
                      classNamePrefix="select"
                      isSearchable={true}
                      placeholder="Seleccionar Ubicación"
                      options={ubicaciones}
                      getOptionLabel={(option) => option.descripcion}
                      getOptionValue={(option) => option.id}
                      onChange={(e) => field.onChange(e.id)}
                      value={ubicaciones.find((x) => x.id === field.value)}
                    />
                  )}
                />

                <p className="text-danger">{errors.empleado?.areaOrganizacionalId?.message}</p>
              </div>

              <div className="form-group">
                <label className="fw-bold">Área Organizacional</label>
                <Controller
                  control={control}
                  name="empleado.areaOrganizacionalId"
                  rules={{
                    validate: (value) => value !== 0 || 'El área organizacional es requerida',
                  }}
                  render={({ field }) => (
                    <Select
                      id="empleado.areaOrganizacionalId"
                      classNamePrefix="select"
                      isSearchable={true}
                      placeholder="Seleccionar Área Organizacional"
                      options={listaAreasState}
                      getOptionLabel={(option) => option.nombre}
                      getOptionValue={(option) => option.id}
                      onChange={(e) => saveAreaOrganizacional({ areaId: e.id, areaOrganizacionales, setValue })}
                      value={listaAreasState.find((x) => x.id === field.value)}
                    />
                  )}
                />

                <p className="text-danger">{errors.empleado?.areaOrganizacionalId?.message}</p>
              </div>

              <div className="form-group">
                <label className="fw-bold">Área Padre</label>
                <Controller
                  control={control}
                  name="empleado.areaOrganizacionalPadreId"
                  rules={{
                    validate: (value) => value !== 0 || 'El área es requerida',
                  }}
                  render={({ field }) => (
                    <Select
                      isDisabled
                      id="empleado.areaOrganizacionalPadreId"
                      classNamePrefix="select"
                      isSearchable={true}
                      placeholder="Seleccionar Área Padre"
                      options={listaAreasState}
                      getOptionLabel={(option) => option.nombre}
                      getOptionValue={(option) => option.id}
                      onChange={(e) => field.onChange(e.id)}
                      value={listaAreasState.find((x) => x.id === field.value)}
                    />
                  )}
                />
                <p className="text-danger">{errors.empleado?.areaOrganizacionalId?.message}</p>
              </div>

              <div className="form-group">
                <label className="fw-bold">Área Máxima</label>
                <Controller
                  control={control}
                  name="empleado.areaMaxima"
                  rules={{
                    validate: (value) => value !== 0 || 'El área máxima es requerida',
                  }}
                  render={({ field }) => (
                    <Select
                      id="empleado.areaMaxima"
                      isDisabled
                      classNamePrefix="select"
                      isSearchable={true}
                      placeholder="Seleccionar Área Organizacional"
                      options={listaAreasState}
                      getOptionLabel={(option) => option.nombre}
                      getOptionValue={(option) => option.id}
                      value={listaAreasState.find((x) => x.id === field.value)}
                    />
                  )}
                />

                <p className="text-danger">{errors.empleado?.areaOrganizacionalId?.message}</p>
              </div>

              <div className="form-group">
                <label className="fw-bold">Cargo</label>

                <Controller
                  control={control}
                  name="empleado.cargoId"
                  rules={{
                    validate: (value) => value !== 0 || 'El cargo es requerido',
                  }}
                  render={({ field }) => (
                    <Select
                      id="empleado.cargoId"
                      classNamePrefix="select"
                      isSearchable={true}
                      placeholder="Seleccionar Cargo"
                      options={listaCargosState}
                      getOptionLabel={(option) => option.titulo}
                      getOptionValue={(option) => option.id}
                      onChange={(e) => field.onChange(e.id)}
                      value={listaCargosState.find((x) => x.id === field.value)}
                    />
                  )}
                />

                <p className="text-danger">{errors.empleado?.cargoId?.message}</p>
              </div>

              <div className="form-group">
                <label className="fw-bold">Área de Evaluación de Desempeño</label>

                <Controller
                  control={control}
                  name="empleado.areaReporteId"
                  rules={{
                    validate: (value) => value !== 0 || 'El Área de Evaluación de Desempeño es requerida',
                  }}
                  render={({ field }) => (
                    <Select
                      id="empleado.areaReporteId"
                      classNamePrefix="select"
                      isSearchable={true}
                      placeholder="Seleccionar Área Reporte"
                      options={listaAreasState}
                      getOptionLabel={(option) => option.nombre}
                      getOptionValue={(option) => option.id}
                      onChange={(e) => field.onChange(e.id)}
                      value={listaAreasState.find((x) => x.id === field.value)}
                    />
                  )}
                />

                <p className="text-danger">{errors.empleado?.areaReporteId?.message}</p>
              </div>

              <div className="form-group">
                <label className="fw-bold">Fecha de Efectividad</label>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    InputProps={{ id: 'fechaEfectividad' }}
                    inputFormat="dd/MM/yyyy"
                    label={' '}
                    mask="__/__/____"
                    value={watch('fechaEfectividad')}
                    onChange={(e) => onChangeFechas({ nombre: 'fechaEfectividad', value: e })}
                    renderInput={(params) => <TextField className="form-control" {...params} />}
                  />
                </LocalizationProvider>

                <p className="text-danger mt-3">{errors.fechaEfectividad?.message}</p>
              </div>
            </div>
          </div>
        </Paper>

        <Paper elevation={5}>
          <Stack mt={2} p={3} component={'div'} id="cuadro-naturaleza">
            <Typography textTransform="uppercase">Naturaleza de la acción</Typography>
            <Divider />

            <Grid container spacing={{ lg: 2, md: 1 }}>
              {tipoAcciones.length > 0 &&
                fields !== undefined &&
                tipoAcciones.map((item, index) => (
                  <Grid item p={2} xs={4} md={4} lg={2.4} key={item.id} mt={2}>
                    <Stack>
                      <Typography key={index} sx={{ fontSize: { lg: 14, md: 12, xs: 11 } }} fontWeight="bold" textTransform="uppercase">
                        {item.nombre}
                      </Typography>

                      {item.tiposAcciones.map((item2, index2) => (
                        <FormControlLabel
                          key={item2.id}
                          sx={{
                            '& .MuiTypography-root': {
                              fontSize: { lg: 14, md: 12, xs: 11 },
                            },
                          }}
                          control={
                            <Checkbox
                              id={`tipoaccion.${item2.id}`}
                              checked={getValues('listaTipoAccion')
                                ?.flat()
                                .some((x) => x === item2.id.toString())}
                              {...register(`listaTipoAccion.${index2}`, {
                                value: [],
                              })}
                              value={item2?.id}
                            />
                          }
                          label={item2?.nombre}
                        />
                      ))}
                    </Stack>
                  </Grid>
                ))}

              <p style={{ marginLeft: 10, marginBottom: -2 }} className="text-danger">
                {watch('listaTipoAccion')?.flat()?.length === 0 && tipoAcciones.length > 0 && 'Debe seleccionar al menos una naturaleza'}
              </p>
            </Grid>
          </Stack>
        </Paper>

        <Paper elevation={5}>
          <Stack mt={2} p={3}>
            <Typography fontSize={14} textTransform="uppercase">
              Detalles explicativos de la acción
            </Typography>
            <TextField
              id="detallesAccion"
              {...register('detallesAccion')}
              label=" "
              variant="outlined"
              multiline
              rows={2}
              sx={{ mb: 2 }}
              error={errors.detallesAccion}
              helperText={errors.detallesAccion?.message}
            />

            <Typography fontSize={14} textTransform="uppercase">
              Para uso de área de recursos humanos
            </Typography>
            <TextField
              id="descripcionRRHH"
              {...register('descripcionRRHH')}
              label=" "
              variant="outlined"
              multiline
              rows={2}
              error={errors.descripcionRRHH}
              helperText={errors.descripcionRRHH?.message}
            />

            <Box mt={2} display="flex" justifyContent="center">
              <button id="btn-guardar" type="submit" disabled={isSubmitting} className="btn btn-primary-mem me-2">
                Guardar <BiSave fontSize={22} />
              </button>

              <button id="btn-cancelar" className="btn btn-danger" onClick={() => navigate('/acciones/reclutamiento')}>
                Cancelar <MdCancel fontSize={22} />
              </button>
            </Box>
          </Stack>
        </Paper>
      </form>

      <InsertarAjustarImagen setValue={setValue} openInsertarImagen={openInsertarImagen} setOpenInsertarImagen={setOpenInsertarImagen} />

      <Loading open={isLoading} />
    </div>
  );
}

export default ReclutamientoSeleccionAgregar;
